import React from "react";
import { WebelieveComp } from "../../components/webelieve/webelievecomp";

const WeBelieve = () => {

    return(

        <>
            <WebelieveComp />
        </>
    )
}

export default WeBelieve;